import React from "react";
import { Button } from "react-bootstrap";
import { ChefHat, CheckSquare } from "lucide-react";

const FinalCard = ({ isActive, onClick, onShowFeedback }) => {
    return (
        <div
            style={{
                scrollSnapAlign: 'start',
                opacity: isActive ? 1 : 0.6,
                transition: 'opacity 0.3s ease'
            }}
            onClick={onClick}
        >
            <div className={`card h-100 rounded-4 border-0 bg-success bg-opacity-10 d-flex align-items-center justify-content-center text-center p-4 transition-all ${isActive ? 'shadow-lg ring-2 ring-success' : ''}`}>
                <div className="mb-3 bg-white p-3 rounded-circle shadow-sm text-success">
                    <ChefHat size={32} />
                </div>
                <h4 className="font-serif fw-bold text-success mb-2">Guten Appetit!</h4>
                <p className="font-sans text-muted mb-4 small">Du hast es geschafft.</p>
                <Button
                    variant="success"
                    className="rounded-pill px-4 fw-bold shadow-sm d-flex align-items-center gap-2"
                    onClick={(e) => { e.stopPropagation(); onShowFeedback(); }}
                >
                    <CheckSquare size={18} /> Als gekocht markieren
                </Button>
            </div>
        </div>
    );
};

export default FinalCard;
